export default __webpack_public_path__ + "static/concerned-134ed6ad3126966c7ea2a7e41f783b03.svg";